export default {
    'cdnBaseUrl': 'https://cdn.elluciancloud.com/assets/EDS2/',
    'appVersion': '4.1.0'
};